import useOptimisticCreateCustomFieldGroup from '@/api/mutations/account/optimistic/useOptimisticCreateCustomFieldGroup';
import { useCustomFieldsForRole } from '@/hooks/useCustomFieldsForRole';
import { CustomFieldGroupRole } from '@payaca/types/custom-fields';

import { FC, ReactNode, useEffect } from 'react';
import { v4 as uuid } from 'uuid';
import { CustomFieldGroupControl } from '../customFieldGroupControl/CustomFieldGroupControl';

export const CompanySettingsCustomFieldGroup: FC<{
  role: CustomFieldGroupRole;
  subHeading: string;
  headerAction?: ReactNode;
}> = ({ role, subHeading, headerAction }) => {
  const { customFieldGroups, fieldGroup: customFieldGroup } =
    useCustomFieldsForRole(role);

  const { mutateAsync: createCustomFieldGroup } =
    useOptimisticCreateCustomFieldGroup();

  useEffect(() => {
    if (customFieldGroups && !customFieldGroup) {
      void createCustomFieldGroup({ role, id: uuid() });
    }
  }, [customFieldGroups, customFieldGroup, createCustomFieldGroup, role]);

  if (!customFieldGroup) {
    return null;
  }

  return (
    <CustomFieldGroupControl
      customFieldGroup={customFieldGroup}
      subHeading={subHeading}
      headerAction={headerAction}
    />
  );
};
